export default __webpack_public_path__ + "abe9366efc4c59aae1f212f73df728fe.png";